// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__q6kg8","bigColWidth":"Table_bigColWidth__U_B6r","biggerColWidth":"Table_biggerColWidth__19L8y","row":"Table_row__1ZezQ","col":"Table_col__l1vNd"};